import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { apiUrl } from 'core/http/lg-logistic-rest-api/api/api.service';
import { Observable } from 'rxjs';

export interface SequenceOutput {
  name: string;
  description: string;
  current: number;
}

@Injectable()
export class SequencesService {
  constructor(private http: HttpClient) { }

  getAllSequences(): Observable<SequenceOutput[]> {
    return this.http.get<SequenceOutput[]>(apiUrl('/project/sequences'));
  }

  resetSequenceTo(name: string, resetTo: number): Observable<SequenceOutput> {
    return this.http.patch<SequenceOutput>(apiUrl(`/project/sequence/${name}/reset-to`), { resetTo });
  }
}
